function Mapper () {
  function order(data) {
    const oi = data.order_information
    const { order_details, order_type } = data

    return {
      orderType: order_type,
      orderInformation: {
        id: oi.id_token,
        orderPlacedAt: oi.order_placed_at,
        orderReferenceNumber: oi.order_reference_number,
        orderTotal: oi.order_total,
        status: oi.status,
        isValidForCancellation: oi.is_valid_for_cancelation,
        isValidForSupport: oi.is_valid_for_support,
        orderExpectedDueData:oi.order_expected_due_date
      },
      ecomOrderDetails: order_type === 'ecom' ? order_details.map(product => productDetail(product)) : null,
      sourcingOrderDetails: order_type === 'sourcing'
        ? {
          product_category: order_details.product_category,
          product_category_id: order_details.product_category_id,
          images: order_details.product_images.map((url) => url),
          product_sub_category: order_details.product_sub_category,
          product_sub_category_id: order_details.product_sub_category_id,
          sourcing_request_id: order_details.sourcing_request_id
        }
        : null
    }
  }

  function productDetail(product) {
    return {
      displayPrice: product.display_price,
      images: product.images.map(img => img.url),
      incoTerms: product.inco_terms,
      id: product.product_id_token,
      slug: product.slug,
      name: product.product_name,
      quantity: product.quantity,
      supplier: {
        id: product.supplier.supplier_id_token,
        name: product.supplier.supplier_name
      }
    }
  }

  function orderDetail (data, tickets) {
    const oa = data.order_addresses
    const ap = data.additional_purchases
    const oi = data.order_information
    const total = data.totals

    return {
      result: true,
      supportTickets: tickets,
      additionalPurchases: {
        hasPurchasedInspection: ap.has_purchased_inspection,
        hasPurchasedInsurance: ap.has_purchased_insurance,
        hasPurchasedTesting: ap.has_purchased_testing,
        hasSignedUpForDrs: ap.has_signed_up_for_drs
      },
      addresses: {
        billingAddress: oa.billing_address,
        billingFullName: oa.billing_full_name,
        billingPhoneNumber: oa.billing_phone_number,
        shippingAddress: oa.shipping_address,
        shippingFullName: oa.shipping_full_name,
        shippingPhoneNumber: oa.shipping_phone_number,
      },
      orderInformation: {
        id: oi.id_token,
        orderPlacedAt: oi.order_placed_at,
        orderReferenceNumber: oi.order_reference_number,
        orderTotal: oi.order_total,
        status: oi.status
      },
      orderDetails: data.order_details.map(product => {
        return {
          displayPrice: product.display_price,
          images: product.images.map(img => img.url),
          incoTerms: product.inco_terms,
          orderDetailsStatusHistory: product.order_details_status_history,
          port: product.port,
          id: product.product_id_token,
          slug: product.slug,
          name: product.product_name,
          quantity: product.quantity,
          supplier: {
            id: product.supplier.supplier_id_token,
            name: product.supplier.supplier_name
          },
          total: product.total
        }
      }),
      payment: {
        paymentMethod: data.payment.payment_method,
        paymentInfo: {
          brand: data.payment.payment_info.brand,
          last4Digits: data.payment.payment_info.last_4_digits
        }
      },
      totals: {
        drsSignUpCharges: total.drs_sign_up_charges,
        exportInsurance: total.export_insurance,
        grandTotal: total.grand_total,
        inspectionCharges: total.inspection_charges,
        orderTotal: total.order_total,
        platformCharges: total.platform_charges,
        taxTotal: total.tax_total
      }
    }
  }

  function orderSupportTickets(tickets) {
    return tickets.map(ticket => {
      return {
        additionalNotes: ticket.additional_notes,
        id: ticket.id_token,
        issueDescription: ticket.issue_description,
        issueTitle: ticket.issue_title,
        ticketNumber: ticket.ticket_number
      }
    })
  }

  return {
    order,
    orderDetail,
    orderSupportTickets
  }
}

export default Mapper()